import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asescomputerapplication',
    templateUrl: './asescomputerapplication.component.html',
    styleUrls: ['./asescomputerapplication.component.scss']
})
export class AsescomputerapplicationComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
